module.exports = __webpack_public_path__ + "static/entrada-hotel-e93611d79128eaf426b7ece7f3b0e91b.jpg";